export default __webpack_public_path__ + "static/media/logo.169892f4.svg";